import { request } from '@umijs/max';
import type { ServerMenuDataItem } from '@/types/menu';

/**
 * 获取服务端菜单列表
 * @param options - 可选参数（如用户角色、租户ID等）
 */
export async function fetchServerMenu(options?: { [key: string]: any }) {
  return request<{
    success: boolean;
    data: ServerMenuDataItem[];
    message?: string;
  }>('/api/user/menu', {
    method: 'GET',
    options,
  });
}
